var _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _mask5, _ellipse5, _path5, _mask6, _ellipse6, _path6, _mask7, _ellipse7, _path7, _mask8, _ellipse8, _path8, _mask9, _ellipse9, _path9, _mask10, _ellipse10, _path10, _mask11, _ellipse11, _path11, _mask12, _ellipse12, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.92274C3 5.73892 3.15536 5.4612 3.5 5.4612V7.4612C4.39693 7.4612 5 6.70133 5 5.92274H3ZM3.5 5.4612C3.84464 5.4612 4 5.73892 4 5.92274H2C2 6.70133 2.60307 7.4612 3.5 7.4612V5.4612ZM4 5.92274C4 6.10656 3.84464 6.38428 3.5 6.38428V4.38428C2.60307 4.38428 2 5.14415 2 5.92274H4ZM3.5 6.38428C3.15536 6.38428 3 6.10656 3 5.92274H5C5 5.14415 4.39693 4.38428 3.5 4.38428V6.38428Z",
    fill: "#001F3B",
    mask: "url(#path-1-inside-1_779_4359)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.07704C3 7.89322 3.15536 7.6155 3.5 7.6155V9.6155C4.39693 9.6155 5 8.85562 5 8.07704H3ZM3.5 7.6155C3.84464 7.6155 4 7.89322 4 8.07704H2C2 8.85562 2.60307 9.6155 3.5 9.6155V7.6155ZM4 8.07704C4 8.26085 3.84464 8.53857 3.5 8.53857V6.53857C2.60307 6.53857 2 7.29845 2 8.07704H4ZM3.5 8.53857C3.15536 8.53857 3 8.26085 3 8.07704H5C5 7.29845 4.39693 6.53857 3.5 6.53857V8.53857Z",
    fill: "#001F3B",
    mask: "url(#path-3-inside-2_779_4359)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.2308C3 10.047 3.15536 9.76931 3.5 9.76931V11.7693C4.39693 11.7693 5 11.0094 5 10.2308H3ZM3.5 9.76931C3.84464 9.76931 4 10.047 4 10.2308H2C2 11.0094 2.60307 11.7693 3.5 11.7693V9.76931ZM4 10.2308C4 10.4147 3.84464 10.6924 3.5 10.6924V8.69238C2.60307 8.69238 2 9.45226 2 10.2308H4ZM3.5 10.6924C3.15536 10.6924 3 10.4147 3 10.2308H5C5 9.45226 4.39693 8.69238 3.5 8.69238V10.6924Z",
    fill: "#001F3B",
    mask: "url(#path-5-inside-3_779_4359)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.92274C5 5.73892 5.15536 5.4612 5.5 5.4612V7.4612C6.39693 7.4612 7 6.70133 7 5.92274H5ZM5.5 5.4612C5.84464 5.4612 6 5.73892 6 5.92274H4C4 6.70133 4.60307 7.4612 5.5 7.4612V5.4612ZM6 5.92274C6 6.10656 5.84464 6.38428 5.5 6.38428V4.38428C4.60307 4.38428 4 5.14415 4 5.92274H6ZM5.5 6.38428C5.15536 6.38428 5 6.10656 5 5.92274H7C7 5.14415 6.39693 4.38428 5.5 4.38428V6.38428Z",
    fill: "#001F3B",
    mask: "url(#path-7-inside-4_779_4359)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.07704C5 7.89322 5.15536 7.6155 5.5 7.6155V9.6155C6.39693 9.6155 7 8.85562 7 8.07704H5ZM5.5 7.6155C5.84464 7.6155 6 7.89322 6 8.07704H4C4 8.85562 4.60307 9.6155 5.5 9.6155V7.6155ZM6 8.07704C6 8.26085 5.84464 8.53857 5.5 8.53857V6.53857C4.60307 6.53857 4 7.29845 4 8.07704H6ZM5.5 8.53857C5.15536 8.53857 5 8.26085 5 8.07704H7C7 7.29845 6.39693 6.53857 5.5 6.53857V8.53857Z",
    fill: "#001F3B",
    mask: "url(#path-9-inside-5_779_4359)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.2308C5 10.047 5.15536 9.76931 5.5 9.76931V11.7693C6.39693 11.7693 7 11.0094 7 10.2308H5ZM5.5 9.76931C5.84464 9.76931 6 10.047 6 10.2308H4C4 11.0094 4.60307 11.7693 5.5 11.7693V9.76931ZM6 10.2308C6 10.4147 5.84464 10.6924 5.5 10.6924V8.69238C4.60307 8.69238 4 9.45226 4 10.2308H6ZM5.5 10.6924C5.15536 10.6924 5 10.4147 5 10.2308H7C7 9.45226 6.39693 8.69238 5.5 8.69238V10.6924Z",
    fill: "#001F3B",
    mask: "url(#path-11-inside-6_779_4359)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.92274C7 5.73892 7.15536 5.4612 7.5 5.4612V7.4612C8.39693 7.4612 9 6.70133 9 5.92274H7ZM7.5 5.4612C7.84464 5.4612 8 5.73892 8 5.92274H6C6 6.70133 6.60307 7.4612 7.5 7.4612V5.4612ZM8 5.92274C8 6.10656 7.84464 6.38428 7.5 6.38428V4.38428C6.60307 4.38428 6 5.14415 6 5.92274H8ZM7.5 6.38428C7.15536 6.38428 7 6.10656 7 5.92274H9C9 5.14415 8.39693 4.38428 7.5 4.38428V6.38428Z",
    fill: "#001F3B",
    mask: "url(#path-13-inside-7_779_4359)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.07704C7 7.89322 7.15536 7.6155 7.5 7.6155V9.6155C8.39693 9.6155 9 8.85562 9 8.07704H7ZM7.5 7.6155C7.84464 7.6155 8 7.89322 8 8.07704H6C6 8.85562 6.60307 9.6155 7.5 9.6155V7.6155ZM8 8.07704C8 8.26085 7.84464 8.53857 7.5 8.53857V6.53857C6.60307 6.53857 6 7.29845 6 8.07704H8ZM7.5 8.53857C7.15536 8.53857 7 8.26085 7 8.07704H9C9 7.29845 8.39693 6.53857 7.5 6.53857V8.53857Z",
    fill: "#001F3B",
    mask: "url(#path-15-inside-8_779_4359)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.2308C7 10.047 7.15536 9.76931 7.5 9.76931V11.7693C8.39693 11.7693 9 11.0094 9 10.2308H7ZM7.5 9.76931C7.84464 9.76931 8 10.047 8 10.2308H6C6 11.0094 6.60307 11.7693 7.5 11.7693V9.76931ZM8 10.2308C8 10.4147 7.84464 10.6924 7.5 10.6924V8.69238C6.60307 8.69238 6 9.45226 6 10.2308H8ZM7.5 10.6924C7.15536 10.6924 7 10.4147 7 10.2308H9C9 9.45226 8.39693 8.69238 7.5 8.69238V10.6924Z",
    fill: "#001F3B",
    mask: "url(#path-17-inside-9_779_4359)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-10_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 5.92274,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.92274C9 5.73892 9.15536 5.4612 9.5 5.4612V7.4612C10.3969 7.4612 11 6.70133 11 5.92274H9ZM9.5 5.4612C9.84464 5.4612 10 5.73892 10 5.92274H8C8 6.70133 8.60307 7.4612 9.5 7.4612V5.4612ZM10 5.92274C10 6.10656 9.84464 6.38428 9.5 6.38428V4.38428C8.60307 4.38428 8 5.14415 8 5.92274H10ZM9.5 6.38428C9.15536 6.38428 9 6.10656 9 5.92274H11C11 5.14415 10.3969 4.38428 9.5 4.38428V6.38428Z",
    fill: "#001F3B",
    mask: "url(#path-19-inside-10_779_4359)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-11_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 8.07704,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.07704C9 7.89322 9.15536 7.6155 9.5 7.6155V9.6155C10.3969 9.6155 11 8.85562 11 8.07704H9ZM9.5 7.6155C9.84464 7.6155 10 7.89322 10 8.07704H8C8 8.85562 8.60307 9.6155 9.5 9.6155V7.6155ZM10 8.07704C10 8.26085 9.84464 8.53857 9.5 8.53857V6.53857C8.60307 6.53857 8 7.29845 8 8.07704H10ZM9.5 8.53857C9.15536 8.53857 9 8.26085 9 8.07704H11C11 7.29845 10.3969 6.53857 9.5 6.53857V8.53857Z",
    fill: "#001F3B",
    mask: "url(#path-21-inside-11_779_4359)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-12_779_4359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 10.2308,
    rx: 0.5,
    ry: 0.538462,
    fill: "#001F3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.2308C9 10.047 9.15536 9.76931 9.5 9.76931V11.7693C10.3969 11.7693 11 11.0094 11 10.2308H9ZM9.5 9.76931C9.84464 9.76931 10 10.047 10 10.2308H8C8 11.0094 8.60307 11.7693 9.5 11.7693V9.76931ZM10 10.2308C10 10.4147 9.84464 10.6924 9.5 10.6924V8.69238C8.60307 8.69238 8 9.45226 8 10.2308H10ZM9.5 10.6924C9.15536 10.6924 9 10.4147 9 10.2308H11C11 9.45226 10.3969 8.69238 9.5 8.69238V10.6924Z",
    fill: "#001F3B",
    mask: "url(#path-23-inside-12_779_4359)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 1.4V1.9H9.38889H11.5556C12.0909 1.9 12.5 2.31866 12.5 2.8V12.6C12.5 13.0813 12.0909 13.5 11.5556 13.5H1.44444C0.909131 13.5 0.5 13.0813 0.5 12.6V2.8C0.5 2.31866 0.909131 1.9 1.44444 1.9H3.61111H4.11111V1.4V0.5H4.55556V1.4V1.9H5.05556H7.94444H8.44444V1.4V0.5H8.88889V1.4ZM0.944444 12.6V13.1H1.44444H11.557H12.0571L12.057 12.5999L12.0556 2.8V2.79993L11.0556 2.8V2.80007V3H1.44444H0.944444V3.5V12.6Z",
    fill: "#001F3B",
    stroke: "#001F3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.a9628502f648cb4cc1d158606eb812f8.svg";
export { ForwardRef as ReactComponent };